/* eslint-disable react-hooks/exhaustive-deps */
import { format } from 'date-fns';
import { useEffect } from 'react';
import editImg from '../../../assets/edit.svg';
import trashImg from '../../../assets/trash_full.svg';
import cashImg from '../../../assets/attach_money.svg';
import { useInvoicesTable } from '../../../context/TableContext';
import {
  Container,
  ResumoContainer,
  TableItem,
  ActionsButtons,
  TableItemContent,
} from './styles';

export const InvoiceDataTable = () => {
  const { faturaParcela, faturaParcelas, setFaturasParcelas, page } =
    useInvoicesTable();

  const { openCashModal, openDeleteModal, openEditModal } = useInvoicesTable();

  function formatoDatas(data: string) {
    if (page === 'register') {
      return data.split('-').reverse().join('/');
    } else {
      const dataFormatada = format(new Date(data), 'dd/MM/yyyy');
      return dataFormatada;
    }
  }

  useEffect(() => {
    const fatura = faturaParcelas.find(
      (fatura) => fatura.fatura.documento === faturaParcela.fatura.documento,
    );

    setFaturasParcelas(fatura ? fatura : { fatura: {} as any, parcelas: [] });
  }, [faturaParcelas]);

  return (
    <Container>
      <div className="content-table">
        <p>Resumo da Fatura</p>

        <ResumoContainer>
          <thead>
            <tr>
              <th>Nº Parc</th>
              <th>Nº Contrato</th>
              <th>Tipo Contrato</th>
              <th>Valor Parc</th>
              <th>Vencimento</th>
              <th>Valor Pago</th>
              <th>Data de Pagamento</th>
              <th></th>
            </tr>
          </thead>

          <tbody>
            {faturaParcela.parcelas?.map((parcela) => {
              return (
                <TableItem>
                  <TableItemContent>{parcela?.nroparc}</TableItemContent>
                  <TableItemContent>{parcela?.documento}</TableItemContent>
                  <TableItemContent>
                    {faturaParcela.fatura.tipodoc}
                  </TableItemContent>
                  <TableItemContent isEditable>
                    {new Intl.NumberFormat('pt-BR', {
                      style: 'currency',
                      currency: 'BRL',
                    }).format(parcela?.valorparc)}
                  </TableItemContent>
                  <TableItemContent isEditable>
                    {formatoDatas(parcela?.vencimento)}
                  </TableItemContent>
                  <TableItemContent>
                    {parcela.valorPago
                      ? new Intl.NumberFormat('pt-BR', {
                          style: 'currency',
                          currency: 'BRL',
                        }).format(parcela.valorPago)
                      : '-'}
                  </TableItemContent>
                  <TableItemContent>
                    {parcela?.pagamento
                      ? formatoDatas(parcela?.pagamento)
                      : '-'}
                  </TableItemContent>

                  <ActionsButtons>
                    <img
                      src={cashImg}
                      alt="Editar Valor"
                      onClick={() =>
                        openCashModal(parcela?.documento, parcela?.nroparc)
                      }
                    />
                    <img
                      src={editImg}
                      className="img"
                      alt="Editar"
                      onClick={() =>
                        openEditModal(parcela?.documento, parcela?.nroparc)
                      }
                    />
                    <img
                      src={trashImg}
                      className="img"
                      alt="Excluir"
                      onClick={() =>
                        openDeleteModal(
                          faturaParcela,
                          parcela?.documento,
                          parcela?.nroparc,
                          true,
                          parcela?.valorparc,
                        )
                      }
                    />
                  </ActionsButtons>
                </TableItem>
              );
            })}

            <TableItem>
              <TableItemContent></TableItemContent>
              <TableItemContent></TableItemContent>
              <TableItemContent></TableItemContent>
              <TableItemContent></TableItemContent>
              <TableItemContent></TableItemContent>
              <TableItemContent></TableItemContent>
              <TableItemContent></TableItemContent>
              <TableItemContent></TableItemContent>
            </TableItem>
          </tbody>
        </ResumoContainer>
      </div>
    </Container>
  );
};
